export function validateNumberInput({
  value,
  min,
  max,
  fieldName,
}: {
  value: string | number;
  min: number;
  max: number;
  fieldName?: string;
}) {
  if (Number(value) > max) {
    return `${
      fieldName ? `${fieldName} cannot` : 'Cannot'
    } be more than ${max}`;
  }
  if (Number(value) < min) {
    return `${
      fieldName ? `${fieldName} cannot` : 'Cannot'
    } be less than ${min}`;
  }
  return /^\d+$/.test(`${value}`) || 'Please only enter numbers';
}
